<template>
    <div class='banner'>
        <!-- <img :src="imgSrc[0].banner" alt=""> -->
         <!-- 轮播 -->
        <div>
            <el-carousel :height="height" :interval="4000" indicator-position="none" :arrow="arrow">
                <el-carousel-item v-for="(item,index) in imgSrc" :key="index">
                    <img :src="url + item.banner" alt="" @click="goPage(item)">
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
    export default {    
        props:{
            imgSrc:{
                type:Array,
                default(){
                    return []
                }
            }
        },
        data(){
            return {
                url:process.env.VUE_APP_WEB_URL,
                height:'400px',
                arrow:'hover'
            }
        },
        created(){
            if(this.$IsMobile()){
                this.height = '2.5rem'
                this.arrow = 'never'
            }
        },
        methods:{
            goPage(item){
                if(item.link){
                    window.location.href = item.link
                }
            }
        }
    }
</script>
<style scoped>
.el-carousel__item img{
    width:100%;
}
.banner img{
    max-height: 400px;
}
@media screen and (max-width: 768px){
    .banner img{
        max-height: 100%;
    }
}
</style>